var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Ttdk = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_1111)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25 38H-0.75V51H50.25V38Z",
    fill: "url(#paint0_linear_47_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.23 10.5H13.885C10.9 10.5 9.39999 12.015 9.39999 15.03V39H17.5V33.375C17.5 32.76 18.01 32.25 18.625 32.25C19.24 32.25 19.75 32.745 19.75 33.375V39H27.7V15.03C27.7 12.015 26.215 10.5 23.23 10.5ZM22.375 25.125H14.95C14.335 25.125 13.825 24.615 13.825 24C13.825 23.385 14.335 22.875 14.95 22.875H22.375C22.99 22.875 23.5 23.385 23.5 24C23.5 24.615 22.99 25.125 22.375 25.125ZM22.375 19.5H14.95C14.335 19.5 13.825 18.99 13.825 18.375C13.825 17.76 14.335 17.25 14.95 17.25H22.375C22.99 17.25 23.5 17.76 23.5 18.375C23.5 18.99 22.99 19.5 22.375 19.5Z",
    fill: "url(#paint1_linear_47_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 37.875H37.345V33.375C38.77 32.91 39.805 31.575 39.805 30V27C39.805 25.035 38.2 23.43 36.235 23.43C34.27 23.43 32.665 25.035 32.665 27V30C32.665 31.56 33.685 32.88 35.08 33.36V37.875H7.75C7.135 37.875 6.625 38.385 6.625 39C6.625 39.615 7.135 40.125 7.75 40.125H36.145C36.175 40.125 36.19 40.14 36.22 40.14C36.25 40.14 36.265 40.125 36.295 40.125H40.75C41.365 40.125 41.875 39.615 41.875 39C41.875 38.385 41.365 37.875 40.75 37.875Z",
    fill: "url(#paint2_linear_47_1111)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_1111",
    x1: 24.75,
    y1: 38,
    x2: 24.75,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_1111",
    x1: 9.39999,
    y1: 22.6125,
    x2: 27.7,
    y2: 22.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_1111",
    x1: 6.625,
    y1: 30.5317,
    x2: 41.875,
    y2: 30.5317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_1111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Ttdk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2ttdk.5dac9e36.svg";
export { ForwardRef as ReactComponent };